export const SET_PROVIDER_LIST = 'SET_PROVIDER_LIST';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_IMPORT_ITEMS = 'SET_IMPORT_ITEMS';
export const SET_INTEGRATION_PROCESSING = 'SET_INTEGRATION_PROCESSING';

export const SET_LARAVEL_ECHO = 'SET_LARAVEL_ECHO';
export const SET_SOCKET = 'SET_SOCKET';

export const SET_OUTLET_ID = 'SET_OUTLET_ID';

// stock inventory
export const SET_STOCK_INVENTORY_LIST = 'SET_STOCK_INVENTORY_LIST';

// stocks
export const SET_STOCK_LIST = 'SET_STOCK_LIST';

// stock check
export const SET_STOCK_CHECK = 'SET_STOCK_CHECK';
export const ADD_COUNTED_STOCK = 'ADD_COUNTED_STOCK';
export const UPDATE_COUNTED_STOCK = 'UPDATE_COUNTED_STOCK';
export const REMOVE_COUNTED_STOCK = 'REMOVE_COUNTED_STOCK';
export const SAVE_STOCK_VARIANCE = 'SAVE_STOCK_VARIANCE';
export const REMOVE_STOCK_VARIANCE = 'REMOVE_STOCK_VARIANCE';

// stock return
export const SET_STOCK_RETURN = 'SET_STOCK_RETURN';
export const SET_STOCK_RETURN_ATTR = 'SET_STOCK_RETURN_ATTR';
export const ADD_RETURN_STOCK = 'ADD_RETURN_STOCK';
export const UPDATE_RETURN_STOCK = 'UPDATE_RETURN_STOCK';
export const REMOVE_RETURN_STOCK = 'REMOVE_RETURN_STOCK';

// stock receive
export const SET_STOCK_RECEIVE = 'SET_STOCK_RECEIVE';
export const SET_STOCK_RECEIVE_ATTR = 'SET_STOCK_RECEIVE_ATTR';
export const ADD_RECEIVE_STOCK = 'ADD_RECEIVE_STOCK';
export const UPDATE_RECEIVE_STOCK = 'UPDATE_RECEIVE_STOCK';
export const REMOVE_RECEIVE_STOCK = 'REMOVE_RECEIVE_STOCK';

// stock request
export const SET_STOCK_REQUEST = 'SET_STOCK_REQUEST';
export const SET_STOCK_REQUEST_ATTR = 'SET_STOCK_REQUEST_ATTR';
export const ADD_REQUEST_STOCK = 'ADD_REQUEST_STOCK';
export const UPDATE_REQUEST_STOCK = 'UPDATE_REQUEST_STOCK';
export const REMOVE_REQUEST_STOCK = 'REMOVE_REQUEST_STOCK';

// supplier
export const SET_SUPPLIER_LIST = 'SET_SUPPLIER_LIST';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const SET_SUPPLIER_ATTR = 'SET_SUPPLIER_ATTR';

// outlet
export const SET_OUTLET_LIST = 'SET_OUTLET_LIST';

// purchase order
export const SET_PURCHASE_ORDER = 'SET_PURCHASE_ORDER';
export const SET_PURCHASE_ORDER_ATTR = 'SET_PURCHASE_ORDER_ATTR';
export const ADD_PURCHASE_STOCK = 'ADD_PURCHASE_STOCK';
export const UPDATE_PURCHASE_STOCK = 'UPDATE_PURCHASE_STOCK';
export const REMOVE_PURCHASE_STOCK = 'REMOVE_PURCHASE_STOCK';

// product
export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_ORIGINAL_PRODUCT = 'SET_ORIGINAL_PRODUCT';
export const ADD_VARIANT = 'ADD_VARIANT';
export const REMOVE_VARIANT = 'REMOVE_VARIANT';
export const SET_VARIANT_ATTR = 'SET_VARIANT_ATTR';
export const SET_PRODUCT_ATTR = 'SET_PRODUCT_ATTR';
export const SET_OUTLET_INVENTORY_ATTR = 'SET_OUTLET_INVENTORY_ATTR';
export const ADD_OUTLET_INVENTORY = 'ADD_OUTLET_INVENTORY';
export const ADD_COMPOSITE_COMPONENT = 'ADD_COMPOSITE_COMPONENT';
export const REMOVE_COMPOSITE_COMPONENT = 'REMOVE_COMPOSITE_COMPONENT';
export const UPDATE_COMPOSITE_COMPONENT = 'UPDATE_COMPOSITE_COMPONENT';

// tags
export const SET_TAG_LIST = 'SET_TAG_LIST';
export const SET_TAG = 'SET_TAG';
export const ADD_TAG = 'ADD_TAG';
export const SET_TAG_ATTRIBUTE = 'SET_TAG_ATTRIBUTE';

export const SET_PERMISSION_GROUPS = 'SET_PERMISSION_GROUPS';
export const SET_ROLE = 'SET_ROLE';
export const SET_ROLE_LIST = 'SET_ROLE_LIST';
export const ADD_ROLE_PERMISSION = 'ADD_ROLE_PERMISSION';
export const REMOVE_ROLE_PERMISSION = 'REMOVE_ROLE_PERMISSION';

export const SET_USER = 'SET_USER';
export const SET_USER_ATTR = 'SET_USER_ATTR';



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js